import { createTheme } from '@mui/material/styles';

/** Resolve optional OEM colors once for both MUI and generated article CSS. */
export function getThemeColors(config, requestedMode) {
    const mode = config.features.themes && requestedMode === 'dark' ? 'dark' : 'light';
    const colors = config.palette[mode] || config.palette.light;
    return {
        ...colors,
        mode,
        accent: colors.accent || (mode === 'dark' && config.palette.accent) || colors.primary,
        progress: colors.progress || config.palette.progress || colors.primary,
    };
}

/** Components read colors through useTheme or sx tokens inside ThemeProvider. */
export function createAppTheme(config, mode) {
    const colors = getThemeColors(config, mode);
    return createTheme({
        palette: {
            mode: colors.mode,
            primary: { main: colors.primary },
            secondary: { main: colors.secondary },
            accent: { main: colors.accent },
            progress: { main: colors.progress },
            background: { default: colors.background, paper: colors.paper },
            text: { primary: colors.text },
        },
        brand: {
            header: config.headerBar[colors.mode] || config.headerBar.light,
        },
        breakpoints: {
            values: { xs: 0, sm: 800, md: 900, lg: 1200, xl: 1536 },
        },
        typography: {
            fontFamily: config.fonts.body,
            ...Object.fromEntries(
                ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].map(variant => [
                    variant, { fontFamily: config.fonts.heading },
                ]),
            ),
            button: { fontFamily: config.fonts.body },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: { textTransform: 'none', fontWeight: 600 },
                },
            },
            MuiTabs: {
                styleOverrides: {
                    indicator: { backgroundColor: colors.accent },
                },
            },
            MuiTab: {
                styleOverrides: {
                    root: ({ theme }) => ({
                        color: theme.palette.text.secondary,
                        fontWeight: 600,
                        '&.Mui-selected': { color: theme.palette.accent.main },
                    }),
                },
            },
            MuiCircularProgress: {
                styleOverrides: { root: { color: colors.progress } },
            },
            MuiLinearProgress: {
                styleOverrides: { bar: { backgroundColor: colors.progress } },
            },
            MuiMenuItem: {
                styleOverrides: { root: { minHeight: 'auto' } },
            }
        },
    });
}
